module.exports = __webpack_public_path__ + "static/media/kawasaki.3d888d77.webp";